// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixField } from './PFixField';
export class PFixPublicKeyField extends PFixField {
    constructor(fieldId, buffer) {
        super(fieldId, buffer);
        this.Value = null;
    }
    ReadValue(buffer) {
        const certificateSize = buffer.ReadShort();
        const certificateBytes = buffer.ReadBuffer(certificateSize).ReadAllBytes();
        this.Value = certificateBytes;
    }
    Write(buffer) {
        buffer.WriteShort(this.FieldId);
        if (this.Value == null) {
            return;
        }
        buffer.WriteShort(this.Value.length);
    }
}
